import { render } from "./UpdateApplicantView.vue?vue&type=template&id=6b381ee0"
import script from "./UpdateApplicantView.vue?vue&type=script&lang=js"
export * from "./UpdateApplicantView.vue?vue&type=script&lang=js"

import "./UpdateApplicantView.vue?vue&type=style&index=0&id=6b381ee0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__